import React, { type PropsWithChildren } from 'react';
import { MsalProvider } from '@azure/msal-react';
import OauthInnerAuthContextProvider from './OauthInnerAuthProvider';
import { msalInstance } from '../../services/MsalAuthService';


const OauthAuthContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    return <MsalProvider instance={msalInstance} >
        <OauthInnerAuthContextProvider>
            {children}
        </OauthInnerAuthContextProvider>
    </MsalProvider >;
};

export default OauthAuthContextProvider;